import {Link}from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import "../Contact/Contact.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faPhoneAlt,faMapMarkedAlt,faEnvelope} from '@fortawesome/free-solid-svg-icons';

import AOS from 'aos';


function Contact (){
    
    AOS.init();

    return(
     <div id="#">
         <div className=" container-fluid bg-secondary pt-2 pt-lg-5 pb-2 mb-5">
            <div className="container py-5">
                <div className="row row-box align-items-center py-4">
                    <div className="col-md-6 text-center text-md-left">
                        <h1 className="mb-4 mb-md-0 text-white">Contact</h1>
                     </div>
                        <div className="col-md-6 text-center text-md-right">
                            <div className="d-inline-flex align-items-center">
                                <Link className="btn text-white" to="/">Home</Link>
                                <FontAwesomeIcon className="fas fa-angle-right text-white" icon={faAngleRight} />
                              
                                <Link className="btn text-white disabled" to="/Contact">Contact</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="contact wow fadeInUp" id="#contact" data-aos={"fade-up"} >
                <div className="container">
                    <div className="section-header text-center">
                    <p>CONTACT</p>
                    <h2>Information request</h2>
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                    <div className="contact-info">
                    <div className="contact-item">
                    <i className="flaticon-address" icon={faMapMarkedAlt} ></i>
                    <div className="contact-text">
                    <h2>Adress</h2>
                    <p> Tunis, Tunisia <br/> Ouagadougou , Burkina Faso</p>
                    </div>
                    </div>
                    <div className="contact-item">
                    <i className="flaticon-call" icon={faPhoneAlt} ></i>
                    <div className="contact-text">
                    <h2>Phone</h2>
                    <p>+216 53 266 284 <br/>+216 95 531 748 </p>
                    </div>
                    </div>
                    <div className="contact-item">
                    <i className="flaticon-send-mail" icon={faEnvelope} ></i>
                    <div className="contact-text">
                    <h2>Email</h2>
                    <p>pemi.tunisia@gmail.com</p>
                    
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className="col-md-6">
                    <div className="contact-form">
                    <div id="success"></div>
                    <form name="sentMessage" action="mailto:melkiimohamed39@gmail.com" method="post" id="contactForm"  enctype="text/plain">
                    <div className="control-group">
                    <input type="text" className="form-control" name="name" placeholder="Your Name" required="required" data-validation-required-message="Please enter your name"/>
                    <p className="help-block text-danger"></p>
                    </div>
                    <div className="control-group">
                    <input type="email" className="form-control" inamed="email" placeholder="Your Email" required="required" data-validation-required-message="Please enter your email"/>
                    <p className="help-block text-danger"></p>
                    </div>
                    <div className="control-group">
                    <input type="text" className="form-control" name="subject" placeholder="Subject" required="required" data-validation-required-message="Please enter a subject"/>
                    <p className="help-block text-danger"></p>
                    </div>
                    <div className="control-group">
                    <textarea className="form-control" name="Objet" placeholder="Message" required="required" data-validation-required-message="Please enter your message"></textarea>
                    <p className="help-block text-danger"></p>
                    </div>
                    <div>
                      
                    <button className="btn"  type="submit" id="sendMessageButton" >Send Message</button>                    </div>
                    </form>
                    </div>
                    </div>
                    </div>
                </div>
            </div>
     </div>
    );
}
export default Contact;